import React, { useState } from 'react'
import { StyledFollowersNumber, StyledSymbol, StyledSocMedPlatform, StyledLink } from './styled'
import './css/textHover.css'

interface Props {
  media: any
  keys: any
}

const SocialMediaDetail = (props: Props) => {
  const { media, keys } = props
  const [onHover, setOnHover] = useState(false)

  return (
    <StyledLink
      href={media.link}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <div style={{ display: 'flex', paddingTop: '20px', alignItems: 'center' }}>
        <StyledFollowersNumber className={onHover ? 'glitch' : ''} data-text={media[keys]}>
          {media[keys]}
        </StyledFollowersNumber>
        <StyledSymbol className={onHover ? 'glitch' : ''} data-text="@">
          @
        </StyledSymbol>
        <StyledSocMedPlatform className={onHover ? 'glitch' : ''} data-text={keys}>
          {keys}
        </StyledSocMedPlatform>
      </div>
    </StyledLink>
  )
}

export default SocialMediaDetail
